const students = {

  edit: {
    tabs: {
      information: 'Información',
      notes: 'Notas',
      parents: 'Padres',
      caregivers: 'Cuidadores',
      history: 'Historia',
      bookingHistory: 'Historial de reservas'
    },
  },
  table: {
    headers: {
      createBtn: 'Crear',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Telefono',
      homeAddress: 'Dirección de domicilio',
      alternateAddress: 'Dirección alternativa',
      schoolAddress: 'La escuela',
      createdAt: 'Creado en',
    },
  },
  form: {
    header: {
      create: {
        title: 'Crear',
      },

      update: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    actions: {
      header: 'Acciones',
      buttons: {
        resetPassword: 'Restablecer contraseña',
      },
    },

    create: {
      confirmButtonText: 'Enviar',
      toasts: {
        success: 'Padre creado correctamente',
        error: 'Ocurrió un error al crear el padre',
      },
    },
    update: {
      formTabs: {
        informationTab: 'Información',
        notesTab: 'Notas',
      },

      activeStatus: {
        statusActive: 'Activo',
        statusDeactivate: 'Inactiva',
      },

      suspend: {
        actionActivate: 'Reactivar',
        actionDeactivate: 'Suspender',
        suspendModal: {
          popupTitleDeactivation: 'Suspender pasajero',
          popupTitleActive: 'Suspender Motivo',
          popupTitleUnsuspend: 'Motivo de remover suspensión',
          popupSubTitleDeactivation: 'Selecciona el motivo de la suspensión',
          popupActionActive: 'Reactivar pasajero',
          popupActionDeactivate: 'Suspender pasajero',
        },
      },
      toasts: {
        success: 'Padre actualizado correctamente',
        error: 'Ocurrió un error al actualizar el padre',
        fetchError: 'Algo salió mal, inténtelo de nuevo.',
      },
    },
    sections: {
      profiles: {
        fields: {
          label: 'Perfiles'
        }
      },
      attributes: {
        fields: {
          label: 'Perfiles'
        }
      },
      personalDetails: {
        header: 'Detalles personales',
        fields: {
          firstName: {
            label: 'Nombre',
          },
          lastName: {
            label: 'Apellido',
          },
          email: {
            label: 'Correo electrónico',
          },
          phone: {
            label: 'Telefono',
          },
          additionalPhone: {
            label: 'Teléfono adicional',
          },
          gender: {
            label: 'Genero',
          },
          dateBirth: {
            label: 'Fecha de Nacimiento',
          },
        },
      },
      schoolDetails: {
        header: 'Detalles de la escuela',
        fields: {
          school: {
            label: 'La escuela',
          },
          academicYear: {
            label: 'Ano académico',
            options: {
              default: 'Por defecto',
              current: '2022-2023',
            },
          },
          level: {
            label: 'Nivel',
          },
          class: {
            label: 'Clase',
          },
        },
      },
      profile: {
        header: 'Perfiles',
        fields: {
          profile: 'Perfiles',
        },
      },

      addresses: {
        header: 'Direcciones de los estudiantes',
        fields: {
          mainAddress: {
            label: 'Dirección principal',
          },
          alternateAddress: {
            label: 'Dirección alternativa',
          },
          level: {
            label: 'Nivel',
          },
          class: {
            label: 'Clase',
          },
        },
      },
      linkParents: {
        header: 'Padres',
        add: 'Añadir',
        entity: 'Padres',

        parentsTable: {
          headers: {
            name: 'Nombre',
            address: 'Dirección',
            phone: 'Telefono',
            email: 'Correo electrónico',
          },
        },
      },

      linkCaregivers: {
        header: 'Cuidadores',
        add: 'Añadir',
        entity: 'Cuidadores',

        caregiversTable: {
          headers: {
            name: 'Nombre',
            address: 'Dirección',
            phone: 'Telefono',
            email: 'Correo electrónico',
          },
        },
      },
    },
  },
};

export default students;
